module.exports = __webpack_public_path__ + "img/ghost_scepter.db657dcd.png";